import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

const SaveChangesButton = ({ onSave, disabled }) => (
    <Button
      onClick={onSave}
      disabled={disabled}
      className="k-button k-button-solid-primary"
      icon="k-icon k-i-save"
    >
      Save Changes
    </Button>
  );

export default SaveChangesButton;
